import { Component, ViewChild } from '@angular/core';

import { AlertTimerComponent } from '../alert-timer/alert-timer.component';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {
  @ViewChild('alertTimer') alertTimer!: AlertTimerComponent;
  @ViewChild('dialog') dialog!: DialogComponent;

  constructor() {
  }


  closeAlertTimer() {
    this.alertTimer.cancelAlert();
  }

  closeDialog() {
    this.dialog.closeDialog(-1);
  }
}
